import React from 'react'
import PropTypes from "prop-types";

import { connect } from 'react-redux'

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";


// @material-ui/core components
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

//Styles
import selectStyles from "assets/jss/material-dashboard-pro-react/customSelectStyle";
//actions
import {
    ibsFetchAll
} from 'actions/ibs'

class SelectIb extends React.Component{
    
    state={
      ibList: [],
    }

    constructor(props){
        super(props)
        this.state.value=props.value
    }
    componentWillMount(){

      this.props.ibsFetchAll().then((r) => {

        r.sort( (a, b) => a.name.localeCompare(b.name, 'en', {'sensitivity': 'base'}));

        this.setState({
            ...this.state,
            ibList:r
          });

      });

      
    }
    
    componentDidMount(){
      
    }

    excludeIbs() {

    }

    render(){
        const {classes,className,title,selectAll,onSelect,excludeData} =this.props
        const {ibList} =this.state

        return   <FormControl
        fullWidth
        className={classes.selectFormControl+' '+className}
      >
        {title?
        <InputLabel htmlFor="ib" className={classes.selectLabel} >
          {title}
        </InputLabel>:''
        }
        <Select
          value={this.state.value}
          MenuProps={{
            className: classes.selectMenu
          }}
          classes={{
            select: classes.select
          }}
          inputProps={{
              onChange: event => {
                this.setState({
                  ...this.state,
                  value:event.target.value
                });
                onSelect(ibList.find(e=>e.ibId===event.target.value))
            },
            id: "ib"
          }}>
          
          {(selectAll?[{
              ibId:0,
              key:0,
              name:'All'
            }]:[]).concat(ibList)
            .map((e) => (
              ((excludeData.length===0) ?
              <MenuItem
                key={e.ibId}
                classes={{
                  root: classes.selectMenuItem
                }}
                value={e.ibId}>
                {e.key === 0
                  ? ((e.lastName) ? e.name + ' ' + e.lastName : e.name)
                  : ((e.lastName) ? e.name + ' ' + e.lastName + ` (${e.ibId})` : e.name + ` (${e.ibId})`)
                }
              </MenuItem> : ((excludeData.length>0) && (excludeData.indexOf(e.ibId) <= -1)) ?
              <MenuItem
                key={e.ibId}
                classes={{
                  root: classes.selectMenuItem
                }}
                value={e.ibId}>
                {e.key === 0
                  ? ((e.lastName) ? e.name + ' ' + e.lastName : e.name)
                  : ((e.lastName) ? e.name + ' ' + e.lastName + ` (${e.ibId})` : e.name + ` (${e.ibId})`)
                }
              </MenuItem> : '')


            ))}
        </Select>


      </FormControl>
    }
}
SelectIb.defaultProps = {
    value:0,
    selectAll:true,
    onSelect:()=>{},
    excludeData:[],
};
  
SelectIb.propTypes = {
    title: PropTypes.string,
    value: PropTypes.number,
    selectAll: PropTypes.bool,
    onSelect: PropTypes.func,
    excludeData: PropTypes.array,

}
const mapStateToProps = (state) => ({
  ibs: state.ibs.list,
})
  const mapDispatchToProps = (dispatch) => ({
    ibsFetchAll: () => dispatch(ibsFetchAll())
  })
export default withStyles(selectStyles)(connect(mapStateToProps,mapDispatchToProps)(SelectIb))


// WEBPACK FOOTER //
// ./src/views/Ibs/Select.jsx